import { useEffect, useState } from 'react';
import {
  FaBuilding,
  FaCity,
  FaHouse,
  FaHouseChimney,
  FaStore,
  FaTree,
} from 'react-icons/fa6';
import { Link } from 'react-router-dom';
import axiosInstance from '../axios';
import '../styles/category.css';

const ICON_MAP = {
  FaHouse: FaHouse,
  FaBuilding: FaBuilding,
  FaHouseChimney: FaHouseChimney,
  FaTree: FaTree,
  FaStore: FaStore,
  FaCity: FaCity,
};

const FALLBACK_ICON = FaBuilding;

const NAME_ICON_MAP = {
  villa: FaHouseChimney,
  vila: FaHouseChimney,
  rumah: FaHouse,
  apartmen: FaBuilding,
  apartment: FaBuilding,
  penthouse: FaBuilding,
  bungalow: FaHouseChimney,
  kavling: FaTree,
  tanah: FaTree,
  ruko: FaStore,
  kantor: FaCity,
  kost: FaBuilding,
  gedung: FaCity,
  gudang: FaBuilding,
};

const resolveIcon = (cat) => {
  if (cat.icon && ICON_MAP[cat.icon]) {
    return ICON_MAP[cat.icon];
  }
  const key = cat.name?.toLowerCase().trim().split(/\s+/)[0] || '';
  return NAME_ICON_MAP[key] || FALLBACK_ICON;
};

const SkeletonCard = () => (
  <div className="category__card category__card--skeleton" aria-hidden="true">
    <div className="category__icon category__icon--skeleton" />
    <div className="category__content">
      <div className="category__skeleton-line category__skeleton-line--title" />
      <div className="category__skeleton-line category__skeleton-line--count" />
    </div>
  </div>
);

const CategorySection = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    setLoading(true);
    setError(false);

    axiosInstance
      .get('/listing-properties/categories', {
        headers: { 'X-Platform': 'Web' },
        signal: controller.signal,
      })
      .then((res) => {
        if (res.data?.data) {
          setCategories(res.data.data);
        }
      })
      .catch((err) => {
        if (!controller.signal.aborted) {
          setError(true);
        }
      })
      .finally(() => {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      });

    return () => controller.abort();
  }, []);

  const formatCount = (count) =>
    new Intl.NumberFormat('id-ID').format(Number(count || 0));

  if (error) {
    return null;
  }

  return (
    <section className="category" aria-labelledby="category-title">
      <div className="category__inner">
        <header className="category__header">
          <h2 id="category-title" className="category__title">
            Jelajahi Properti
          </h2>
          <p className="category__subtitle">
            Pilih kategori properti sesuai kebutuhan Anda
          </p>
        </header>

        <div className="category__grid">
          {loading
            ? Array.from({ length: 4 }).map((_, i) => <SkeletonCard key={i} />)
            : categories.map((cat) => {
                const IconComponent = resolveIcon(cat);
                return (
                  <Link
                    key={cat.slug || cat.id}
                    to={`/properties?category=${cat.slug || cat.name.toLowerCase()}`}
                    className="category__card"
                  >
                    <div className="category__icon">
                      <IconComponent />
                    </div>

                    <div className="category__content">
                      <h3>{cat.name}</h3>
                      <p>{formatCount(cat.properties_count)} Properti</p>
                    </div>
                  </Link>
                );
              })}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;
